var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-container is-flex"},[_c('h5',{staticClass:"title is-5 is-flex has-text-primary"},[_vm._t("header")],2),_c('div',{staticClass:"panel-content is-flex"},[_vm._t("summary-category"),_vm._t("summary-number")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }